import React, { useEffect, useState } from "react";
import MainLayout from "../components/MainLayout";
import { mainTable } from "../css/Common";
import InputText from "../ReusableComponents/InputText";
import { BindAPI, BindPostAPI } from "../services/APIConnection";
import ReportGridPage from "../components/ReportGridPage";
import MultiSelect from "../ReusableComponents/MultiSelect";
import * as XLSX from "sheetjs-style";
import { useUserCapability } from "../components/ConstantReducerProvider";
import {
  enquiryReportHeaders,
  stockLedgerReportHeaders,
  stockReportHeaders,
} from "../components/HeaderAttribute";

const StockReport = () => {
  const { userProfileState } = useUserCapability();
  const [tillDate, setTillDate] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const mstClientId =
    sessionStorage.getItem("MstClientId") &&
      sessionStorage.getItem("MstClientId") !== "null"
      ? Number(sessionStorage.getItem("MstClientId"))
      : 0;
  const [stockReportFields, setStockReportFields] = useState({
    itemType: [],
    itemCategory: [],
    item: [],
  });
  const [stockReportFieldsError, setStockReportFieldsError] =
    useState({
      itemTypeError: "",
      itemCategoryError: "",
      itemError: "",
    });
  const [bindStockReports, setBindStockReports] = useState([]);
  const [showTable, setShowTable] = useState(false);

  const [bindItemType, setBindItemType] = useState([]);
  const [bindItemCategory, setBindItemCategory] = useState([]);
  const [bindItem, setBindItem] = useState([]);


  const [bindItemCategoryDD, setBindItemCategoryDD] = useState([]);
  const [bindItemDD, setBindItemDD] = useState([]);

  const GoButton = async () => {
    debugger
    const itemTypeValidate = stockReportFields.itemType
      ? ""
      : "Select Item Type";
    const itemCategoryValidate = stockReportFields.itemCategory
      ? ""
      : "Select Item Category";

    const itemValidate = stockReportFields.item ? "" : "Select Item";

    setStockReportFieldsError({
      ...stockReportFieldsError,
      itemTypeError: itemTypeValidate,
      itemCategoryError: itemCategoryValidate,
      itemError: itemValidate,
    });

    let itemTypeArray = Array.from(
      { length: stockReportFields.itemType.length },
      (v, i) => stockReportFields.itemType[i]
    );
    let itemTypeResult = itemTypeArray.join(",");

    let itemCategoryArray = Array.from(
      { length: stockReportFields.itemCategory.length },
      (v, i) => stockReportFields.itemCategory[i]
    );
    let itemCategoryResult = itemCategoryArray.join(",");

    let itemArray = Array.from(
      { length: stockReportFields.item.length },
      (v, i) => stockReportFields.item[i]
    );
    let itemResult = itemArray.join(",");

    if (!itemTypeValidate && !itemCategoryValidate && !itemValidate) {
      const ReportData = {
        itemType: itemTypeResult,
        itemCategory: itemCategoryResult,
        item: itemResult,
        fromDate: fromDate,
        toDate: toDate,
        mstClientId: mstClientId,
      };
      const response = await BindPostAPI(
        ReportData,
        "StockReportAPI/StockReport"
      );

      setBindStockReports(response.data.Table);
      setShowTable(true);
    } else {
    }
  };

  const handleExport = () => {
    exportData(
      stockReportHeaders.map((column) => column.title),
      bindStockReports
    );
  };

  const exportData = (columns, rows) => {
    const titleRow = [
      {
        v: "Stock Report",
        s: {
          font: { bold: true, sz: 16 },
          alignment: { horizontal: "left" },
        },
      },
    ];

    const spacingRow = [{ v: "" }];

    const headerRow = columns.map((column) => ({
      v: column,
      s: {
        fill: { fgColor: { rgb: "000000" } },
        font: { bold: true, color: { rgb: "FFFFFF" } },
        alignment: { horizontal: "left" },
      },
    }));

    const dataRows = rows.map((rowData, index) => {
      const isAlternateRow = index % 2 === 1;
      const baseStyle = isAlternateRow
        ? { fill: { fgColor: { rgb: "F0F0F0" } } }
        : {};

      return [
        {
          v: index + 1,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },

        {
          v: rowData.ItemType,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.ItemCategory,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.ItemName,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },

        {
          v: rowData.OpeningQty,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.TotalPurchase,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.TotalReceipt,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.TotalIssue,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.TotalConsumption,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
        {
          v: rowData.TotalDamage,
          s: { ...baseStyle, alignment: { horizontal: "left" } },
        },
         
        {
          v: rowData.ClosingQty,
          s: {
            ...baseStyle,
            alignment: { horizontal: "left" },
            font: {
              color: { rgb: rowData.ClosingQty <= rowData.ItemReOrderLevel ? "FF0000" : "000000" }
            }
          },
        },
      ];
    });

    const wsData = [titleRow, spacingRow, headerRow, ...dataRows];
    const ws = XLSX.utils.aoa_to_sheet(wsData);

    ws["!cols"] = [
      { width: 8 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 }, // dynamic width with cap
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
    ];

    // Set row heights
    ws["!rows"] = [
      { hpt: 30 },
      { hpt: 15 },
      { hpt: 15 },
      { hpt: 15 },
      { hpt: 15 },
      ...Array(rows.length).fill({ hpt: 15 }),
    ];

    // Apply borders
    const applyStyles = (ws) => {
      const range = XLSX.utils.decode_range(ws["!ref"]);
      for (let R = range.s.r; R <= range.e.r; R++) {
        for (let C = range.s.c; C <= range.e.c; C++) {
          const cellRef = XLSX.utils.encode_cell({ r: R, c: C });
          if (!ws[cellRef]) continue;

          ws[cellRef].s = {
            ...ws[cellRef].s,
            border: {
              top: { style: "thin", color: { rgb: "000000" } },
              bottom: { style: "thin", color: { rgb: "000000" } },
              left: { style: "thin", color: { rgb: "000000" } },
              right: { style: "thin", color: { rgb: "000000" } },
            },
          };
        }
      }
    };

    applyStyles(ws);

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, "Stock Report.xlsx");
  };

  const downloadPDF = () => { };

  useEffect(() => {
    const today = new Date();
    const currentYear = today.getFullYear();
    const automaticFromDate = `${currentYear}-01-01`;
    setFromDate(automaticFromDate);

    const formattedToDate = today.toISOString().split("T")[0];
    setToDate(formattedToDate);
  }, []);

  const stockLedgerReportFieldsChange = (value, name) => {
    setStockReportFields({
      ...stockReportFields,
      [name]: value,
    });
    // if (name === "itemType"){
    //     // reset selected categories & items (use [] not "")
    //   setStockReportFields({
    //     ...stockReportFields,
    //     itemCategory: [],
    //     item: [],
    //   });
    // }
  };
  useEffect(() => {
    BindStockLedgerDDValues();
  }, []);

  const BindStockLedgerDDValues = async () => {
    const data = {
      mstClientId: mstClientId,
    };
    const response = await BindPostAPI(
      data,
      "StockReportAPI/BindStockLedgerDDValues"
    );

    if (response && response.data) {
      const itemTypeDD = response?.data.Table.map((item) => ({
        value: item.MstItemTypeId,
        label: item.ItemType,
      }));

      setBindItemType(itemTypeDD);

      const itemCategory = response?.data.Table1.map((item) => ({
        value: item.MstItemCategoryId,
        label: item.ItemCategory,
        type: item.MstItemTypeId,
      }));
      setBindItemCategory(itemCategory);

      const itemDD = response?.data.Table2.map((item) => ({
        value: item.MstItemId,
        label: item.ItemName,
        category: item.MstItemCategoryId,
      }));
      setBindItem(itemDD);
    }
  };

  return (
    <MainLayout pageName="4">
      <div>
        <div class="relative m-3 bg-white rounded-lg ">
          <div class="mt-3 py-4">
            <div className={mainTable.headerTitle}>
              <div className="my-2 mx-12 lg:mx-0">{`Stock Report`}</div>
            </div>
            <div class="mt-3">
              <div className={mainTable.grid3}>
                <div>
                  <MultiSelect
                    classStar="text-red-500"
                    label="Item Type"
                    filteredOptions={bindItemType}
                    classFilterLabel="p-1 flex gap-1"
                    class="custom-class"
                    placeholder={
                      stockReportFields.itemType?.length > 0
                        ? "More Selected"
                        : "Select..."
                    }
                    name="itemType"
                    selectedOptions={stockReportFields.itemType}
                    classDiv="relative w-full inline-block"
                    //                     onChange={(e) => {
                    //                       
                    //                       setShowTable(false);
                    //                       stockLedgerReportFieldsChange(e, "itemType");
                    //                       setBindItemCategoryDD([]);
                    //                       setBindItemDD([]);
                    // // filter categories based on new ItemType selection
                    //   const filteredCategories = bindItemCategory.filter((v) =>
                    //     e.includes(v.type)   // if multiple item types selected
                    //   );

                    //   setBindItemCategoryDD(filteredCategories);
                    //   setBindItemDD([]); // reset item dropdown
                    //                       setStockReportFields({
                    //                         ...stockReportFields,

                    //                         itemCategory: "",
                    //                         item: "",
                    //                       });
                    //                     }}
                    onChange={(e) => {
                      setShowTable(false);

                      // update selected item type
                      stockLedgerReportFieldsChange(e, "itemType");

                      // filter categories for new type(s)
                      const filteredCategories = bindItemCategory.filter((v) =>
                        e.includes(v.type)
                      );

                      setBindItemCategoryDD(filteredCategories); // update categories
                      setBindItemDD([]); // clear items

                      // reset selected categories & items (use [] not "")
                      //   setStockReportFields({
                      //     ...stockReportFields,
                      //     itemCategory: [],
                      //     item: [],
                      //   });
                    }}
                    classLabel={mainTable.labelNoWrap}
                  />
                  {stockReportFieldsError.itemTypeError && (
                    <span className="text-red-500">
                      {stockReportFieldsError.itemTypeError}
                    </span>
                  )}
                </div>
                <div>
                  <MultiSelect
                    classStar="text-red-500"
                    label="Item Category"
                    filteredOptions={bindItemCategoryDD}
                    classFilterLabel="p-1 flex gap-1"
                    class="custom-class"
                    placeholder={
                      stockReportFields.itemCategory?.length > 0
                        ? "More Selected"
                        : "Select..."
                    }
                    name="itemCategory"
                    selectedOptions={stockReportFields.itemCategory}
                    classDiv="relative w-full inline-block"
                    onChange={(e) => {
                      setShowTable(false);
                      stockLedgerReportFieldsChange(e, "itemCategory");
                      // filter items based on new categories
                      const filteredItems = bindItem.filter((v) =>
                        e.includes(v.category)
                      );
                      setBindItemDD(filteredItems);
                      //   setStockReportFields({
                      //     ...stockReportFields,
                      //     item: "",
                      //   });
                    }}
                    classLabel={mainTable.labelNoWrap}
                  />
                  {stockReportFieldsError.itemCategoryError && (
                    <span className="text-red-500">
                      {stockReportFieldsError.itemCategoryError}
                    </span>
                  )}
                </div>
                <div>
                  <MultiSelect
                    classStar="text-red-500"
                    label="Item"
                    filteredOptions={bindItemDD}
                    classFilterLabel="p-1 flex gap-1"
                    class="custom-class"
                    placeholder={
                      stockReportFields.item?.length > 0
                        ? "More Selected"
                        : "Select..."
                    }
                    name="item"
                    selectedOptions={stockReportFields.item}
                    classDiv="relative w-full inline-block"
                    onChange={(e) => {
                      setShowTable(false);
                      stockLedgerReportFieldsChange(e, "item");
                    }}
                    classLabel={mainTable.labelNoWrap}
                  />
                  {stockReportFieldsError.itemError && (
                    <span className="text-red-500">
                      {stockReportFieldsError.itemError}
                    </span>
                  )}
                </div>
              </div>
              <div class={mainTable.grid3}>
                <InputText
                  inputType="date"
                  title="From"
                  name="fromDate"
                  content={fromDate}
                  controlFunc={(e) => {
                    setShowTable(false);
                    setFromDate(e.target.value);
                  }}
                />
                <InputText
                  inputType="date"
                  title="To"
                  name="toDate"
                  content={toDate}
                  controlFunc={(e) => {
                    setShowTable(false);
                    setToDate(e.target.value);
                  }}
                />
                <div class="flex justify-start items-center mt-6">
                  <button
                    type="button"
                    onClick={() => GoButton()}
                    className={mainTable.addButton}
                  >
                    GO
                  </button>
                </div>
              </div>
            </div>
          </div>
          {showTable &&
            (bindStockReports.length > 0 ? (
              <div className=" ">
                <ReportGridPage
                  title=""
                  header={stockReportHeaders}
                  records={bindStockReports}
                  handleExport={handleExport}
                  handlePDF={downloadPDF}
                // xScroll=" max-md:w-fit w-full"
                />
              </div>
            ) : (
              <div className="flex items-center justify-center">
                No record found
              </div>
            ))}
        </div>
      </div>
    </MainLayout>
  );
};

export default StockReport;
